import React, { Fragment } from 'react'
import actions from 'redux/actions'
import { useCallback, useEffect, useMedia } from 'sb-hooks'
import { constants, links, mixpanel } from 'common/helpers'

import { Box, Overlay } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import Modal from 'components/_new/modal/Modal/Modal'
import { Button, ButtonsInRow } from 'components/_new/controls'
import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'

import s from './TossInModal.scss'
import messages from './messages'


const TossInModal = () => {
  const { isMobile } = useMedia()

  const close = useCallback(() => {
    actions.models.modals.close(constants.modals.humble.tossIn)
    actions.models.ui.setClosedPopup(constants.modals.humble.tossIn)
  }, [])

  const onClick = useCallback(() => {
    mixpanel.track(constants.analyticsEvents.tossInPopUp.click)
    close()
  }, [ close ])

  useEffect(() => {
    mixpanel.track(constants.analyticsEvents.tossInPopUp.appear)
  }, [])

  return (
    <Fragment>
      <ModalContainer>
        <Overlay onClick={close} />
        <Modal className={s.tossInModal} onClose={close}>
          <Box mb={24}>
            <Text
              message={messages.title}
              tag="span"
              size={isMobile ? '28-40' : '32-40'}
              semibold
              html
            />
          </Box>
          <Text
            className={s.text}
            message={messages.text}
            html
          />
          <Box mt={40}>
            <ButtonsInRow alignLeft>
              <Button
                className={s.button}
                title={messages.buttonTitle}
                size="md"
                color="brand"
                rightIcon="rightArrowSmall"
                fullWidthOnMobile
                to={links.tossIn}
                onClick={onClick}
              />
            </ButtonsInRow>
          </Box>
        </Modal>
      </ModalContainer>
    </Fragment>
  )
}


export default TossInModal
